import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, Output, EventEmitter, inject } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { BasketItemRequest } from "../dtos/basket-item.request.dto";
import { CheckBasketRequest } from "../dtos/check-basket.request.dto";
import { InitPaymentRequest } from "../dtos/init-payment.request.dto";
import { UrlParam } from "../models/url-param";
import { SessionStorageService } from "./session-storage.service";
import { RefundRequest } from "../dtos/refund.request.dto";
import HwUtil from "../utils/hw-util";

@Injectable({ providedIn: 'root' })
export class ShopService {
    private httpClient = inject<HttpClient>(HttpClient);
    private sessionStorageService = inject(SessionStorageService);

    private apiUrlBase = environment.apiServer;
    private oauthServerBaseUrl = environment.oauthServerBaseUrl;

    public isAuthTokenExpired(): boolean {
        const token = this.sessionStorageService.getAuthToken();
        if (!token)
            return true;

        return token.ExpiresIn < new Date();
    }

    public login(urlParam: UrlParam): Observable<any> {
        const headers = new HttpHeaders().set("Content-Type", 'application/x-www-form-urlencoded');

        let request = new URLSearchParams();
        request.set('username', urlParam.Subscriber)
        request.set('password', urlParam.HotelId.toString())
        request.set('client_id', environment.clientId)
        request.set('client_secret', environment.clientSecret)
        request.set('grant_type', "password");
        request.set('scope', `${environment.oauthScope}`);

        let url = `${this.oauthServerBaseUrl}/connect/token`;

        return this.httpClient.post(url, request, { headers: headers });
    }

    public getInitData() {
        let url = `${this.apiUrlBase}/shop/init`;
        return this.httpClient.get(url);
    }

    public getSubscriberinfo() {
        let url = `${this.apiUrlBase}/subscriberinfo`;
        return this.httpClient.get(url);
    }

    public getAllAreas(date: Date) {
        let formattedDate = HwUtil.DateToISOString(date);
        let url = `${this.apiUrlBase}/areas/${formattedDate}`;
        return this.httpClient.get(url);
    }

    public getAllGroups(date: Date, areaId?: string) {
        let url = `${this.apiUrlBase}/ticketgroups/search`;
        let request = { areaId: areaId, date: HwUtil.DateToISOString(date) };
        return this.httpClient.post(url, request);
    }

    public getTickets(date: Date, areaId?: string, ticketGroupId?: string) {
        let url = `${this.apiUrlBase}/tickets/search`;
        let request = { areaId: areaId, date: HwUtil.DateToISOString(date), ticketGroupId: ticketGroupId };
        return this.httpClient.post(url, request);
    }

    public getBasketPrices(basket: BasketItemRequest[]) {
        let url = `${this.apiUrlBase}/shop/basket`;
        return this.httpClient.post(url, { items: basket });
    }

    public checkBasket(basket: CheckBasketRequest) {
        let url = `${this.apiUrlBase}/shop/checkbasket`;
        return this.httpClient.post(url, basket);
    }

    public checkInvoice(basket: CheckBasketRequest) {
        let url = `${this.apiUrlBase}/shop/checkinvoice`;
        return this.httpClient.post(url, basket);
    }

    public initPayment(initPaymentRequest: InitPaymentRequest) {
        let url = `${this.apiUrlBase}/shop/initpayment`;
        return this.httpClient.post(url, initPaymentRequest);
    }

    public checkPayment(paymentTransactionId: string) {
        let url = `${this.apiUrlBase}/shop/checkpayment`;
        return this.httpClient.post(url, { "paymentTransactionId": paymentTransactionId });
    }

    public refund(request: RefundRequest) {
        let url = `${this.apiUrlBase}/shop/refund`;
        return this.httpClient.post(url, request);
    }

    public checkRefund(request: RefundRequest) {
        let url = `${this.apiUrlBase}/shop/checkRefund`;
        return this.httpClient.post(url, request);
    }
}
